export default __webpack_public_path__ + "static/media/GU.935bb98c.svg";